<template>
  <div>
    <main>
      <section>
        <div class="container">
          <div class="row">
            <div class="col_xl_6 col_l_6 col_m_12 col_s_12">
              <div class="text_block w522">
                <p class="big tac">Use hot links</p>

                <h3 class="tac">Quick access to any call through hot links.</h3>
              </div>
            </div>

            <div class="col_xl_6 col_l_6 col_m_12 col_s_12">
              <div class="img_wrap w522 right">
                <img src="@/assets/img/main_1.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div class="container">
          <div class="row">
            <div class="col_xl_6 col_l_6 col_m_12 col_s_12 order_m_2 order_s_2">
              <div class="img_wrap w522">
                <img src="@/assets/img/main_2.png" alt="" />
              </div>
            </div>

            <div class="col_xl_6 col_l_6 col_m_12 col_s_12 order_m_1 order_s_1">
              <div class="text_block w522 right">
                <p class="big tac">Blurred screen</p>

                <h3 class="tac">
                  The blurred screen will help to concentrate attention of
                  interlocutors only on your silhouette.
                </h3>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div class="container">
          <div class="row">
            <div class="col_xl_6 col_l_6 col_m_12 col_s_12">
              <div class="text_block w522">
                <p class="big tac">More than 24+ people</p>

                <h3 class="tac">Ideal for large teams.</h3>
              </div>
            </div>

            <div class="col_xl_6 col_l_6 col_m_12 col_s_12">
              <div class="img_wrap w522 right">
                <img src="@/assets/img/main_3.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="build_room">
        <div class="container">
          <div class="row">
            <div class="col_xl_12 col_l_12 col_m_12 col_s_12">
              <p class="big tac">
                Build a flexible room <br />
                system for different needs
              </p>
            </div>
          </div>

          <div class="row">
            <div class="col_xl_4 col_l_4 col_m_12 col_s_12">
              <div class="need">
                <img src="@/assets/img/key_icon.svg" alt="" />

                <h3 class="tac">GDPR compliant</h3>

                <p class="tac">
                  GDPR and ePrivacy compliant service that cares about the
                  privacy of your data.
                </p>
              </div>
            </div>

            <div class="col_xl_4 col_l_4 col_m_12 col_s_12">
              <div class="need">
                <img src="@/assets/img/trust_icon.svg" alt="" />

                <h3 class="tac">Trusted by around the world</h3>

                <p class="tac">
                  A fast, easy and reliable tool for online meetings that many
                  people trust.
                </p>
              </div>
            </div>

            <div class="col_xl_4 col_l_4 col_m_12 col_s_12">
              <div class="need">
                <img src="@/assets/img/no_delay_icon.svg" alt="" />

                <h3 class="tac">No delay</h3>

                <p class="tac">There is never a delay on the stream.</p>
              </div>
            </div>
          </div>

          <div class="row">
            <div
              class="
                col_xl_2
                xl_offset_5
                col_l_2
                l_offset_5
                col_m_4
                m_offset_4
                col_s_12
              "
            >
              <router-link to="/pricing" class="color_btn hover_op try_free wider"
                >Try for free</router-link
              >
            </div>
          </div>
        </div>
      </section>

      <section>
        <div class="container">
          <div class="row">
            <div class="col_xl_6 col_l_6 col_m_12 col_s_12 order_m_2 order_s_2">
              <div class="img_wrap w522">
                <img src="@/assets/img/main_4.png" alt="" />
              </div>
            </div>

            <div class="col_xl_6 col_l_6 col_m_12 col_s_12 order_m_1 order_s_1">
              <div class="text_block w522 right">
                <span class="soon">Soon!</span>

                <p class="big tac">Custom design and branding</p>

                <h3 class="tac">
                  Capture the atmosphere of your brand or <br />
                  present mood.
                </h3>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div class="container">
          <div class="row">
            <div class="col_xl_6 col_l_6 col_m_12 col_s_12">
              <div class="text_block w522">
                <p class="big tac">
                  Stay under<br />
                  control
                </p>

                <h3 class="tac">
                  The key advantage is the ease of use of all the functionality.
                </h3>
              </div>
            </div>

            <div class="col_xl_6 col_l_6 col_m_12 col_s_12">
              <div class="img_wrap w522 right">
                <img src="@/assets/img/main_5.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div class="container">
          <div class="row">
            <div class="col_xl_6 col_l_6 col_m_12 col_s_12 order_m_2 order_s_2">
              <div class="img_wrap w522">
                <img src="@/assets/img/main_6.png" alt="" />
              </div>
            </div>

            <div class="col_xl_6 col_l_6 col_m_12 col_s_12 order_m_1 order_s_1">
              <div class="text_block w522 right">
                <p class="big tac">Any device</p>

                <h3 class="tac">Join a call from any device, anywhere.</h3>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>

    <footerComponent></footerComponent>
  </div>
</template>

<script>
import footerComponent from "@/components/footerComponent.vue";

export default {
  name: "Features",
  components: {
    footerComponent,
  },
};
</script>

<style>
</style>